import React from 'react';
import moment from 'moment';

import EventIcon from './event-icon';
import style from './index.less';

const MessageEventEvalution = props => {
  const { data = {} } = props;
  const { action, content = [], time, agentName } = data;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>{agentName}</li>
        <li>{'编辑顾客名片'}</li>
      </ul>
      <div className={style['event-border']} />
      <div className={style['evaluation-content']}>
        {Array.isArray(content) &&
          content.map(item => {
            const { label, value, oldValue } = item;
            let text = '';
            if (typeof value === 'string' || typeof value === 'number') {
              text = value === 0 || value ? value : '';
            }
            return (
              <div key={`${label}_${value}`}>
                <span>{String(label ?? '')}：</span>
                {oldValue ? (
                  <>
                    <span className={style.old_value}>{oldValue}</span>
                    <span className={style.xgw}>{'修改为'}</span>
                  </>
                ) : null}
                <span>{text}</span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MessageEventEvalution;
